import type { ImportedInvalidClient } from '@/types/clientDetailsApiTypes';

export const INVALID_ROW_FIELDS = [
  { label: 'First name', getValue: (row: ImportedInvalidClient) => row.data.first_name },
  { label: 'Last name', getValue: (row: ImportedInvalidClient) => row.data.last_name },
  { label: 'Email', getValue: (row: ImportedInvalidClient) => row.data.email },
];
